import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { formDataSaqDMe } from "../../data/4.0/formDataSaqDMe";
import ComponentSaq from "../../components/ComponentSaq";

class SaqdMe extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {};
  }

  render() {
    return <ComponentSaq type="D-ME" formDataSaq={formDataSaqDMe} />;
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(SaqdMe);
